import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import "../styles/windParkPage.css";
import {ListItemRows} from "./tableRow"
import { Paper } from "@mui/material";
import { fontWeight } from "@mui/system";

const PaperColor="#37474f";


export default function TurbineTable({ WindTurbine }) {
  
debugger
  return (
    <div >
      <Paper elevation="5" sx={{ opacity:"0.95",bgcolor:PaperColor ,  borderRadius:"20px", padding:"2px",paddingBottom:"10px", paddingTop:"10px"}}  >

      <List
        sx={{ width: "100%" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader" sx={{ bgcolor:PaperColor}}  >
            <h3 style={{ bgcolor:PaperColor, color: "white"}}>Wind Turbine {ShortenNameSlice(WindTurbine.name)}</h3>
          </ListSubheader>
        }
        >
        <ListItemRows wtg={WindTurbine} />
      </List>
        </Paper>
    </div>
  );
}

function ShortenNameSlice(name) {
  if(name!==null){

    let numberArray = name.split("-", 2)
    let stringSlice = name.slice(0, 1 - name.length)
    stringSlice = stringSlice + numberArray[1]
    return stringSlice
  }
  return "None"
}
